import { IconDefinitionProps } from "@store/Framework/Types/Icon";
import { ComponentType } from "react";
import { renderToStaticMarkup } from "react-dom/server";

export default <T extends IconDefinitionProps>(icon: ComponentType<any>, iconProps?: T, iconType = "svg") => {
    if (typeof window === "undefined") {
        return "";
    }

    return `data:image/${iconType}+xml;utf-8,${window.encodeURIComponent(
        renderToStaticMarkup((icon as any).type(iconProps)),
    )}`;
};
